import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ChatBoxConst } from './chat.const';
import { TimeWorker } from '../../../../../common/utils/timeWorker';
import { showPhoneNumberInString } from '../../../../../common/utils/common';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.css'],
})
export class ChatBoxComponent implements OnInit, OnChanges {
  @Input() histories: any = [];
  @Input() messages: any = [];
  @Input() users: any = [];
  @Input() user: any = [];
  @Input() curUser: any = {};
  @Input() templates: any = [];
  @Input() sender: any = {};
  @Input() currentTicket: any = {};
  @Input() tab: any = '';
  @Input() ticket_id: any = '';
  @Input() message_from_template: any = '';

  @Output() onChatting = new EventEmitter<any>();
  @Output() onAction = new EventEmitter<any>();

  public head_status: any = '';
  public image_contact = 'assets/images/contact.png';
  public is_toggle = true;
  public message: any = '';

  protected readonly TimeWorker = TimeWorker;
  protected readonly event = event;

  public readonly showPhoneNumberInString = showPhoneNumberInString;

  constructor() {}

  ngOnInit() {
    const status = this.currentTicket ? this.currentTicket.status : '';
    this.head_status = ChatBoxConst.displayHeadStatus(status);
  }

  toggleSide() {
    this.is_toggle = !this.is_toggle;
  }

  insertLineBreak(textarea: HTMLTextAreaElement): void {
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const value = textarea.value;

    // Insert a line break at the cursor position
    textarea.value = value.substring(0, start) + '\n' + value.substring(end);

    // Move the cursor to the new position after the line break
    textarea.selectionStart = textarea.selectionEnd = start + 1;
  }

  action(type, item?: any) {
    if (type == '_keydown' && item.keyCode == 13 && !item.ctrlKey) {
      item = this.message;
      type = 'chatting';
      setTimeout(() => {
        this.message = '';
      }, 100);
    }
    if (type == '_keydown' && item.keyCode == 13 && item.ctrlKey) {
      const textarea = item.target as HTMLTextAreaElement;
      item.preventDefault();
      this.insertLineBreak(textarea);
    }
    this.onAction.emit({ type: type, value: item });
  }

  uploadFile(type) {
    if (type == 'image') {
      $('#messageImage').trigger('click');
    } else if (type == 'file') {
      $('#messageFile').trigger('click');
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.message_from_template) {
      this.message = this.message_from_template;
      this.message_from_template = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/chat/chat-box/chat-box.component.ts